import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Check, Loader2, ArrowRight } from 'lucide-react';
import { includedFeatures } from '../../../lib/pricingUtils';

export default function UpgradePlanDialog({
  open,
  onOpenChange,
  loading,
  currentPlan,
  targetPlan,
  preview,
  onConfirm,
}) {
  if (!targetPlan) return null;
  const newFeatures = includedFeatures(targetPlan).filter(
    (f) => !(currentPlan?.features || []).some((c) => c.id === f.id && c.included)
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Upgrade your plan</DialogTitle>
          <DialogDescription>
            {currentPlan?.name || 'Current'} → {targetPlan.name}
          </DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4 py-2 text-sm">
          <div className="rounded-lg border p-3 opacity-70">
            <p className="font-medium mb-2">{currentPlan?.name || 'Current'}</p>
            <p className="text-xs text-slate-500">Your current plan</p>
          </div>
          <div className="rounded-lg border border-blue-200 bg-blue-50/50 dark:bg-blue-950/20 p-3">
            <p className="font-medium mb-2">{targetPlan.name}</p>
            <ul className="space-y-1">
              {newFeatures.slice(0, 6).map((f) => (
                <li key={f.id} className="flex items-center gap-1.5 text-emerald-700 dark:text-emerald-400">
                  <Check className="w-3.5 h-3.5" />
                  {f.label || f.id}
                </li>
              ))}
            </ul>
          </div>
        </div>
        {preview && (
          <p className="text-sm text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-900 rounded-md p-3">
            {preview.amount_due_usd != null
              ? preview.is_upgrade
                ? `You'll pay $${Number(preview.amount_due_usd).toFixed(2)} today (plan price difference). Your next renewal will be at the ${targetPlan.name} rate.`
                : `You'll be charged $${Number(preview.amount_due_usd).toFixed(2)} today.`
              : 'Upgrade takes effect immediately after payment. New limits apply right away.'}
          </p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={loading}>
            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ArrowRight className="w-4 h-4 mr-2" />}
            Upgrade now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
